import React, { useState, useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import {
  deleteGrievance,
  getGrievances,
  markAsResolved,
} from "utils/apiService";
import DeleteModal from "Components/Common/DeleteModal";
import GrievanceViewModal from "./GrievanceViewModal";
import moment from "moment";

const actionItemStyle = {
  width: "15px",
  display: "inline-block",
};

function GrievancesList() {
  document.title = "Grievances";
  const [grievances, setGrievances] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedGrievance, setSelectedGrievance] = useState(null);

  useEffect(() => {
    fetchGrievances();
  }, []);

  const fetchGrievances = async () => {
    try {
      const data = await getGrievances();
      setGrievances(data.response);
      console.log("Fetched Grievances:", data.response);
    } catch (err) {
      console.error("Failed to fetch students:", err);
    }
  };

  const handleDelete = (grievance: any) => {
    setSelectedGrievance(grievance);
    setDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      if (selectedGrievance) {
        await deleteGrievance((selectedGrievance as { id: number }).id);
        toast.success("Grievance deleted successfully!");
        fetchGrievances();
      }
    } catch (error) {
      toast.error("Failed to delete grievance.");
      console.error("Delete Error:", error);
    } finally {
      setDeleteModal(false);
      setSelectedGrievance(null);
    }
  };

  const onMarkAsResolvedClick = async (grievance: any) => {
    try {
      if (grievance) {
        await markAsResolved(grievance.id);
        toast.success("Grievance marked as resolved successfully!");
        fetchGrievances();
      }
    } catch (error) {
      toast.error("Failed to mark grievance as resolved.");
      console.error("Resolve Error:", error);
    }
  };

  const handleView = (grievance: any) => {
    setSelectedGrievance(grievance);
    setViewModal(true);
  };

  const handleWhatsApp = (phone: string) => {
    const whatsappUrl = `https://wa.me/${phone}`;
    window.open(whatsappUrl, "_blank");
  };

  const columns = useMemo(
    () => [
      {
        header: "Sr No.",
        cell: (cellProps) => {
          // Adding 1 because array index starts from 0
          return cellProps.row.index + 1;
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Student Name",
        accessorKey: "student_name",
      },
      {
        header: "Student Email",
        accessorKey: "student_email",
      },
      {
        header: "Student Phone",
        accessorKey: "student_phone",
        cell: ({ row }) => {
          const phoneWithCode = row.original.student_phone || "";
          return phoneWithCode.replace(/-/g, " ").replace(/[\(\)]/g, " ");
        },
      },
      /* {
        header: "Description",
        accessorKey: "description",
      }, */
      {
        header: "Inquiry On",
        accessorKey: "created_date",
        cell: (cellProps) => {
          const dateValue = cellProps.row.original.created_date;
          return dateValue ? moment(dateValue).format("DD-MM-YYYY") : "";
        },
      },
      {
        header: "Resolved On",
        accessorKey: "resolved_date",
        cell: (cellProps) => {
          const dateValue = cellProps.row.original.resolved_date;
          return dateValue ? moment(dateValue).format("DD-MM-YYYY") : "";
        },
      },
      {
        header: "Status",
        accessorKey: "status",
      },
      {
        header: "Actions",
        accessorKey: "actions",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => {
          const grievance = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-primary"
                onClick={() => handleView(grievance)}
              >
                <i className="mdi mdi-eye font-size-18" />
              </Link>

              <Link
                to="#"
                className="text-success"
                onClick={() => handleWhatsApp(grievance.student_phone)}
              >
                <i className="mdi mdi-whatsapp font-size-18" />
              </Link>

              <div style={actionItemStyle}>
                {grievance.status !== "Resolved" && (
                  <Link
                    to="#"
                    className="text-warning"
                    onClick={() => onMarkAsResolvedClick(grievance)}
                    title="Mark as Resolved"
                  >
                    <i className="mdi mdi-check-circle font-size-18" />
                  </Link>
                )}
              </div>

              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDelete(grievance)}
              >
                <i className="mdi mdi-delete font-size-18" />
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={confirmDelete}
        onCloseClick={() => setDeleteModal(false)}
        message="Are you sure you want to delete this grievance ? You won't be able to revert this!"
      />
      <GrievanceViewModal
        show={viewModal}
        grievance={selectedGrievance}
        onCloseClick={() => setViewModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs breadcrumbItem="Grievances" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={grievances}
                    isGlobalFilter={false}
                    isAddButton={false}
                    customPageSize={10}
                    isPagination={true}
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100"
                    theadClass="table-light"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}

export default GrievancesList;
